import { render, staticRenderFns } from "./casInfo.vue?vue&type=template&id=b162570a"
import script from "./casInfo.vue?vue&type=script&lang=js"
export * from "./casInfo.vue?vue&type=script&lang=js"
import style0 from "./casInfo.vue?vue&type=style&index=0&id=b162570a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports